import { render, staticRenderFns } from "./poorStudentApplicationNote.vue?vue&type=template&id=ed8814fc&scoped=true"
import script from "./poorStudentApplicationNote.vue?vue&type=script&lang=js"
export * from "./poorStudentApplicationNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8814fc",
  null
  
)

export default component.exports